export default __webpack_public_path__ + "static/media/expand-icon.3254d1ef.svg";